export function formatExecutionSource(source?: string | null): string | null {
  const normalized = source?.trim().toLowerCase();
  if (!normalized) return null;
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}
